import styled from 'styled-components';
import { breakpoints } from '../../styles/theme';
import CheckoutAssistedFinanceTemplate from './CheckoutAssistedFinanceTemplate';
import { rem } from 'polished';

export const CheckoutAssistedFinanceStyled = styled(CheckoutAssistedFinanceTemplate)`
    .description {
        display: flex;
        flex-direction: column;
        gap: ${rem(20)};
        margin-bottom: ${rem(15)};

        @media (min-width: ${breakpoints.sm}px) {
            flex-direction: row;
        }

        .descriptionBox1 {
            margin-bottom: 0;

            @media (min-width: ${breakpoints.sm}px) {
                margin-bottom: ${rem(15)};
            }
        }

        .descriptionBox1,
        .descriptionBox2 {
            width: 100%;
            font-size: ${rem(13)};
            line-height: ${rem(20)};

            @media (min-width: ${breakpoints.sm}px) {
                width: 50%;
            }

            ul {
                padding-left: ${rem(20)};
                margin: 0;
            }

            a {
                font-weight: ${({ theme }) => theme.fontWeights.textBold};
                text-decoration: underline;
                cursor: pointer;
            }
        }

        .descriptionBox2 {
            background: ${({ theme }) => theme.colors.grey20};
            padding: ${rem(24)};
        }
    }

    .select {
        display: flex;
        flex-direction: column;
        gap: ${rem(20)};
        margin-bottom: ${rem(25)};

        @media (min-width: ${breakpoints.sm}px) {
            flex-direction: row;
        }

        .selectLeft,
        .selectRight {
            width: 100%;
            display: flex;
            flex-direction: column;
            padding: ${rem(24)} ${rem(24)} ${rem(24)} ${rem(68)};
            border: 2px solid ${({ theme }) => theme.colors.grey23};
            position: relative;

            &.selected {
                border-color: ${({ theme }) => theme.colors.primary};
                background: ${({ theme }) => theme.colors.red7};
            }

            &:hover,
            &:focus-visible {
                border-color: ${({ theme }) => theme.colors.primary};
                cursor: pointer;
            }

            @media (min-width: ${breakpoints.sm}px) {
                width: 50%;
            }
        }

        .selectIcon {
            position: absolute;
            width: ${rem(25)};
            height: ${rem(25)};
            border-radius: 50%;
            border: 1px solid ${({ theme }) => theme.colors.heavyMetal};
            left: ${rem(20)};
            top: ${rem(30)};
            background: ${({ theme }) => theme.colors.white};

            &.selected {
                border-color: ${({ theme }) => theme.colors.primary};
            }

            .selected {
                position: absolute;
                background: ${({ theme }) => theme.colors.primary};
                width: ${rem(15)};
                height: ${rem(15)};
                border-radius: 50%;
                left: ${rem(4)};
                top: ${rem(4)};
            }
        }

        .selectTitle {
            font-size: ${rem(16)};
        }

        .selectDescription {
            font-size: ${rem(14)};
            color: ${({ theme }) => theme.colors.heavyMetal};
            margin: ${rem(10)} 0 0 0;
            line-height: ${rem(20)};
        }

        .icon {
            svg {
                width: ${rem(48)};
                margin-left: -${rem(10)};
            }
        }
    }

    .isLoading {
        opacity: 0.4;
    }

    .spinner {
        margin: 0 auto ${rem(10)};
    }
`;
